import React from "react";

export const MostlyClearIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="33" fillRule="nonzero" fill="#3F4447">
                <g transform="translate(8.000000, 16.000000)">
                    <path
                        d="M77.333 44.197c0 4.5-3.699 8.135-8.246 8.135H48.003c-.147 0-.289-.018-.424-.052-4.1-.457-7.258-3.89-7.258-8.025 0-4.152 3.172-7.563 7.244-8.023 1.447-4.96 6.085-8.505 11.477-8.505 5.37 0 9.997 3.517 11.462 8.454 3.874.663 6.829 3.994 6.829 8.016zm-8.246 4.62c2.62 0 4.73-2.075 4.73-4.62s-2.11-4.62-4.73-4.62c-.858 0-1.59-.617-1.735-1.46-.675-3.94-4.175-6.875-8.31-6.875-4.177 0-7.7 2.995-8.328 6.985a1.757 1.757 0 01-1.861 1.48 4.916 4.916 0 00-.346-.013c-2.586 0-4.67 2.05-4.67 4.561 0 2.38 1.875 4.363 4.3 4.548.041.003.083.008.125.014h20.825z"
                        fill="#717277"
                    />
                    <path
                        d="M35.327 13.964c1.786.266 2.057 2.73.37 3.379-7.812 3-13.087 10.584-13.087 19.171 0 11.328 9.095 20.505 20.305 20.505 2.733 0 5.389-.545 7.852-1.59 1.666-.705 3.183 1.263 2.076 2.694-5.14 6.646-13.017 10.612-21.54 10.612C16.221 68.735 4 56.405 4 41.201c0-15.203 12.22-27.535 27.303-27.535 1.356 0 2.7.1 4.024.298zM7.515 41.2c0 13.269 10.654 24.02 23.788 24.02 5.28 0 10.272-1.747 14.328-4.842-.896.103-1.803.155-2.716.155-13.159 0-23.82-10.758-23.82-24.02 0-7.71 3.637-14.733 9.467-19.175C16.718 18.712 7.515 28.87 7.515 41.201z"
                        fill="#717277"
                    />
                </g>
            </g>
        </g>
    </svg>
);
